import angular from 'angular';

module.exports = angular.module('market.routes.vendor_help.quality', [])
.config(function($stateProvider) {
  $stateProvider.state('vendor_help.quality', {
    url: '/quality',
    template: require('./quality.jade')(),
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/vendor-help/quality.js
 **/